// «Недавние» в палитре ⌘K (contracts/ui.md): 5 последних открытых записей и разделов.
// Хранятся только в памяти страницы: ФИО коллег не остаются в браузере после выхода
// (принцип IV). Другой пользователь — пустой список.
import { useSyncExternalStore } from 'react';

export interface RecentItem {
  /** Ключ: адрес раздела или записи. */
  key: string;
  label: string;
  /** Адрес внутри сервиса. */
  href: string;
  kind: 'section' | 'user';
}

export const RECENT_LIMIT = 5;

let owner: string | null = null;
let items: readonly RecentItem[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

/** Запомнить открытый раздел или запись; повтор поднимает её наверх. */
export function rememberRecent(userId: string, item: RecentItem): void {
  if (owner !== userId) {
    owner = userId;
    items = [];
  }
  if (items[0]?.key === item.key && items[0].label === item.label) return;
  items = [item, ...items.filter((other) => other.key !== item.key)].slice(0, RECENT_LIMIT);
  emit();
}

/** Забыть всё — для тестов. */
export function clearRecent(): void {
  owner = null;
  items = [];
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const empty: readonly RecentItem[] = [];

/** Недавние текущего пользователя, новые сверху. */
export function useRecent(userId: string): readonly RecentItem[] {
  const snapshot = useSyncExternalStore(
    subscribe,
    () => items,
    () => empty,
  );
  return owner === userId ? snapshot : empty;
}
